import { SortingState } from "@tanstack/react-table";
import { LoadingSpinner } from "PFComponents/loading_spinner";
import Table from "PFComponents/table/table";

import {
  ColumnsGeneratorConfig,
  ImportBaseWithState,
  useColumnsGenerator
} from "./hooks/use_columns_generator";
import css from "./imports_history_table.module.scss";

export type ImportHistoryTableProps<T extends ImportBaseWithState> = {
  data?: T[];
  isLoading: boolean;
  currentPage: number;
  onCurrentPageChange: (page: number) => void;
  totalPages: number;
  sorting?: SortingState;
  onSortingChange: (sorting: SortingState) => void;
} & ColumnsGeneratorConfig<T>;

export const ImportsHistoryTable = <T extends ImportBaseWithState>({
  data,
  isLoading,
  totalPages,
  currentPage,
  onCurrentPageChange,
  sorting,
  onSortingChange,
  isDetailsEnabled,
  displayFileErrorsColumn
}: ImportHistoryTableProps<T>) => {
  const generateColumns = useColumnsGenerator<T>({
    isDetailsEnabled,
    displayFileErrorsColumn
  });

  if (!data && isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className={css.tableWrapper}>
      <Table<T>
        tableData={data || []}
        generateColumns={generateColumns}
        paginationOptions={{ totalPages, currentPage, onClick: onCurrentPageChange }}
        onSortingChange={onSortingChange}
        controlledSorting={sorting}
      />
    </div>
  );
};
